import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import WhatsappButton from "./WhatsappButton";
import ShoppingCartButton from "./ShoppingCartButton";
import PriceListButton from "./PriceListButton";
import CircularText from "./CircularText";

const FloatingActionButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    // Inject keyframes for red wave animation
    const style = document.createElement("style");
    style.textContent = `
      @keyframes redWave {
        0% {
          box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3), 0 0 0 0 rgba(255, 0, 0, 0.8);
        }
        70% {
          box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3), 0 0 0 20px rgba(255, 0, 0, 0);
        }
        100% {
          box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3), 0 0 0 0 rgba(255, 0, 0, 0);
        }
      }
      @keyframes slowRotate {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      {/* Sub-buttons - only show when expanded */}
      <div
        style={{
          position: "fixed",
          bottom: isExpanded ? "80px" : "20px",
          right: "20px",
          opacity: isExpanded ? 1 : 0,
          visibility: isExpanded ? "visible" : "hidden",
          transition: "all 0.3s ease-in-out",
          transform: isExpanded ? "scale(1)" : "scale(0.8)",
          zIndex: 1000,
        }}
      >
        <WhatsappButton />
      </div>

      <div
        style={{
          position: "fixed",
          bottom: isExpanded ? "80px" : "20px",
          right: "20px",
          opacity: isExpanded ? 1 : 0,
          visibility: isExpanded ? "visible" : "hidden",
          transition: "all 0.3s ease-in-out 0.1s",
          transform: isExpanded ? "scale(1)" : "scale(0.8)",
          zIndex: 1000,
        }}
      >
        <ShoppingCartButton />
      </div>

      <div
        style={{
          position: "fixed",
          bottom: isExpanded ? "80px" : "20px",
          right: "20px",
          opacity: isExpanded ? 1 : 0,
          visibility: isExpanded ? "visible" : "hidden",
          transition: "all 0.3s ease-in-out 0.2s",
          transform: isExpanded ? "scale(1)" : "scale(0.8)",
          zIndex: 1000,
        }}
      >
        <PriceListButton />
      </div>

      {/* Main FAB with CircularText */}
      <div
        style={{
          position: "fixed",
          bottom: "55px",
          right: "10px",
          width: "110px",
          height: "110px",
          zIndex: 1001,
          pointerEvents: "none",
        }}
      >
        <CircularText
          text="CONTACT*US*NOW*"
          onHover="speedUp"
          spinDuration={20}
          className="fab-circular-text"
        />
      </div>

      <div
        onClick={toggleExpanded}
        style={{
          position: "fixed",
          bottom: "80px",
          right: "35px",
          width: "60px",
          height: "60px",
          backgroundColor: "#ffffff",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0, 123, 255, 0.3)",
          animation: isExpanded
            ? "none"
            : "redWave 1s infinite, slowRotate 8s linear infinite",
          transition: "all 0.3s ease",
          transform: isExpanded ? "rotate(45deg)" : "rotate(0deg)",
          zIndex: 1002,
          pointerEvents: "auto",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.1)";
          e.currentTarget.style.transform = "scale(1.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#ffffff";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <img
          src="/images/startech_float.png"
          alt="StarTech Logo"
          style={{
            width: "50px",
            height: "50px",
            objectFit: "contain",
          }}
        />
      </div>
    </>
  );
};

export default FloatingActionButton;
